import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConsoleSimple1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconConsoleSimple1"><Path d="M3.5 3.5H20.5V20.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 7.75L8.25 9.5L6.5 11.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconConsoleSimple1;
